import { render, staticRenderFns } from "./IntegrationEmbedder.vue?vue&type=template&id=6d3a1128&scoped=true"
var script = {}
import style0 from "./IntegrationEmbedder.vue?vue&type=style&index=0&id=6d3a1128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3a1128",
  null
  
)

export default component.exports